module.exports = __webpack_public_path__ + "static/media/Cover_February-2015.3776362c.jpg";